import eventQueue from '../queue';
import { EventAction } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (payload) {
        if (payload.data.element === 'ToggleButtonGroup' &&
            payload.data.eventId === 'FullSwitchAndMore-partialToggle') {
            if (payload.data.selected.value === 'amount')
                return payload.fireAnalyticsEvent(EventAction.AMOUNT_SELECTED, {
                    ddAmountOverride: undefined,
                });
        }
        if (payload.data.element === 'Radio' &&
            (payload.data.eventId === 'Legacy.partialPaycheck' ||
                payload.data.eventId === 'FullSwitchAndMore-partialPaycheck')) {
            if (payload.data.checked)
                return payload.fireAnalyticsEvent(EventAction.AMOUNT_SELECTED, {
                    ddAmountOverride: undefined,
                });
        }
        return null;
    });
}
attachEventListeners();
